/**
 * External Imports
 */
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

/**
 * Internal Imports
 */
import SearchHeader from '../../components/searchHeader';
import QuestionBankTable from '../../components/customTables/admin/questionBankTable';

import { RootState } from '../../redux/store';
import {
  getCSVToExportSuccess,
  openModal,
  setModalType,
  editSelectedQuestion
} from '../../redux/actions';

/**
 * Global Type Definition Imports
 */
import { CleanQuestion, Question } from '../../config/interfaces';

/**
 * Style Imports
 */
import { QuestionBankContainer } from './styles/AdminViews.styles';

interface QuestionBankProps {
  questionsOfTemplate: Question[];
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const QuestionBank: FC<QuestionBankProps> = ({
  questionsOfTemplate,
  searchTerm,
  setSearchTerm
}) => {
  const dispatch = useDispatch();

  const [csvData, setCsvData] = useState<CleanQuestion[]>([]);

  const handleExportCsv = () => {
    dispatch(getCSVToExportSuccess(csvData));
    // appInsights.trackEvent({
    //   name: 'Question_List_CSV_Downloaded'
    // });
  };

  const handleEditQuestionOnClick = (id: string) => {
    dispatch(editSelectedQuestion(id));
    dispatch(setModalType('Add Question'));
    dispatch(openModal());
  };

  return (
    <QuestionBankContainer>
      <SearchHeader
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        handleExportCsv={handleExportCsv}
      />
      <QuestionBankTable
        searchTerm={searchTerm}
        questionsList={questionsOfTemplate}
        handleCsvData={setCsvData}
        handleEditQuestion={handleEditQuestionOnClick}
      />
    </QuestionBankContainer>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    questionsOfTemplate: state.TemplateReducer.questionsOfTemplate
  };
};

export default connect(mapReduxStateToProps)(QuestionBank);
